<template>
  <div>
    <div class="logo-wrapper">
      <!-- <Logo /> -->
      <img class="img-fluid d-block my-0 mx-auto" :src="logo" alt="" />
      <div class="back-btn" @click="toggle_sidebar">
        <i class="fa fa-angle-left"></i>
      </div>
      <!-- <div class="toggle-sidebar" @click="toggle_sidebar">
        <vue-feather
          class="status_toggle middle sidebar-toggle"
          type="grid"
          id="sidebar-toggle"
        ></vue-feather>
      </div> -->
    </div>
    <div class="logo-icon-wrapper"></div>
    <Nav />
  </div>
</template>
<script>
import { mapState } from "vuex";
// import Logo from "./logo.vue";
import Nav from "./nav.vue";
import { getCookies, jwtDecode } from "../../utils";

export default {
  name: "Sidebar",
  components: {
    // Logo,
    Nav,
  },
  data() {
    return {
      logo: null,
    };
  },
  computed: {
    ...mapState({
      menuItems: (state) => state.menu.data,
      activeoverlay: (state) => state.menu.activeoverlay,
    }),
  },
  methods: {
    toggle_sidebar() {
      this.$store.dispatch("menu/opensidebar");
      this.$store.state.menu.activeoverlay = false;
    },
    getLogo() {
      let tokenCookies = getCookies("token");
      const decoded = jwtDecode(tokenCookies);
      console.log(decoded.logo);

      if (decoded.logo == null) {
        this.logo = require("@/assets/images/logo/vectolabs_logo.png");
      } else {
        this.logo = decoded.logo;
      }
    },
  },
  mounted() {
    this.getLogo();
  },
};
</script>
